import { Component, OnInit, ViewChild, ElementRef, OnDestroy, AfterViewChecked, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { DeviceDetectorService } from 'ngx-device-detector';
import { deferredPrompt } from '../../../main';


@Component({
    selector: 'app-post-signup-landing',
    templateUrl: './post-signup-landing.component.html',
    styleUrls: ['./post-signup-landing.component.scss'],
    standalone: false
})
export class PostSignupLandingComponent implements OnInit, OnDestroy, AfterViewChecked {
    @ViewChild('cardPreview', { static: false }) cardPreview: ElementRef;
    
    isLoading: boolean = true;
    cardUrl: string;
    isDrawerOpen: boolean = false;
    isDrawerMinimized: boolean = false;
    isIOS: boolean = false;
    isAndroid: boolean = false;
    showIosInstallDrawer: boolean = false;
    showInstallCta: boolean = true;
    isOpenedAsPWA: boolean = false;
    deviceOs: string;
    private readonly ngUnsubscribe: Subject<any> = new Subject();
    private drawerTimeout: any;
    private isCardLoaded: boolean = false;
    private hasInitialized: boolean = false;

    constructor(
        private readonly route: ActivatedRoute,
        private readonly cdr: ChangeDetectorRef,
        private readonly deviceDetectorService: DeviceDetectorService,
    ) {
        window.addEventListener('appinstalled', () => {
            this.showInstallCta = false; 
        });
    }

    ngOnInit() {
        this.route.queryParams
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(params => {
            try {
                let decodedUrl = atob(params['cardurl']);
                decodedUrl = decodedUrl + '?pwa_preview=true&zoom=1.2';
                this.cardUrl = decodedUrl;
                this.isCardLoaded = true;
                this.cdr.detectChanges();
                this.isLoading = false;
            } catch (error) {
                this.isLoading = true;
                console.log("error :", error);
            }
        });
        this.checkPlatform();
    }

    ngAfterViewChecked() {
        if (!this.hasInitialized && this.cardPreview && this.isCardLoaded && !this.isLoading) {
            this.hasInitialized = true;
            this.showDrawerWithDelay();
        }
    }

    checkPlatform() {
        const isMobile = this.deviceDetectorService.isMobile();
        const deviceInfo = this.deviceDetectorService.getDeviceInfo();
        this.deviceOs = deviceInfo.os;
        this.isIOS = isMobile && this.deviceOs === 'iOS';
        this.isAndroid = isMobile && this.deviceOs === 'Android';
    }

    onDrawerOutsideClick() {
        this.isDrawerMinimized = true;
    }

    closeDrawer() {
        this.isDrawerOpen = false;
    }

    private showDrawerWithDelay() {
        if (this.drawerTimeout) {
            clearTimeout(this.drawerTimeout);
        }
        
        this.drawerTimeout = setTimeout(() => {
            this.isDrawerOpen = true;
            this.cdr.detectChanges();
        }, 1500);
    }

    goToDashboard() {
        window.open('https://dashboard.uniqode.com/digital-business-cards/my-cards', '_blank', 'noopener');
    }

    ngOnDestroy() {
        if (this.drawerTimeout) {
            clearTimeout(this.drawerTimeout);
        }
        this.ngUnsubscribe.next(null);
        this.ngUnsubscribe.complete();
        window.removeEventListener('appinstalled', () => {});
    }

    addToHomescreen() {
        if (this.isIOS) {
            this.showIosInstallDrawer = true;
        } else if (deferredPrompt) {
            deferredPrompt.prompt();
            deferredPrompt.userChoice.then((result: any) => {
                if (result.outcome === 'accepted') {
                    console.log('User accepted the A2HS prompt');
                    this.showInstallCta = false;
                } else {
                    console.log('User dismissed the A2HS prompt');
                }
            });
        }
    }

    closeIosInstallDrawer() {
        this.showIosInstallDrawer = false;
    }
}